<!-- =========================================================================================
  File Name: DataListThumbView.vue
  Description: Data List - Thumb View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-thumb-view" class="data-list-container">
    <vs-table
      ref="table"
      v-model="selected"
      pagination
      :max-items="itemsPerPage"
      search
      :data="trash"
    >
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span class="mr-2"
              >{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
              {{
                trash.length - currentPage * itemsPerPage > 0
                  ? currentPage * itemsPerPage
                  : trash.length
              }}
              of {{ queriedItems }}</span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage = 100">
              <span>100</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 200">
              <span>200</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 300">
              <span>300</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 400">
              <span>400</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="code">Código</vs-th>
        <vs-th>Cliente</vs-th>
        <vs-th>Data</vs-th>
        <vs-th>Valor</vs-th>
        <vs-th>Tipo</vs-th>
        <vs-th>Consultor</vs-th>
        <vs-th>Ações</vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="order" :key="indextr" v-for="(order, indextr) in data">
            <vs-td align="center">
              <p class="product-name font-medium truncate">
                <vs-chip color="success">{{ order.idOrder }}</vs-chip>
              </p>
            </vs-td>
            <vs-td>
              <p class="product-name font-medium truncate">
                {{ order.corporateName }}
              </p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">
                {{ order.dateOrder }}
              </p>
            </vs-td>
            <vs-td>
              <p class="product-name font-medium truncate">
                {{ order.totalOrder }}
              </p>
            </vs-td>
            <vs-td v-if="order.orderType == 'Equipamento Revenda'">
              <vs-chip color="success">
                {{ order.orderType }}
              </vs-chip>
            </vs-td>
            <vs-td v-if="order.orderType == 'Equipamento Venda Direta'">
              <vs-chip color="#1E90FF">{{ order.orderType }}</vs-chip>
            </vs-td>
            <vs-td v-if="order.orderType == 'Peças'">
              <vs-chip color="danger">{{ order.orderType }}</vs-chip>
            </vs-td>
            <vs-td v-if="order.orderType == 'Mão de Obra'">
              <vs-chip color="warning">{{ order.orderType }}</vs-chip>
            </vs-td>
            <vs-td v-if="order.orderType == 'Suprimentos'">
              <vs-chip color="#1E90FF">{{ order.orderType }}</vs-chip>
            </vs-td>
             <vs-td v-if="order.orderType == 'Mídias'">
              <vs-chip color="success">{{ order.orderType }}</vs-chip>
            </vs-td>
            <vs-td v-if="order.orderType == 'Suprimentos Locação'">
              <vs-chip color="#1E90FF">
                {{ order.orderType }}
              </vs-chip>
            </vs-td>
            <vs-td v-if="order.orderType == 'Locação'">
              <vs-chip color="primary">{{ order.orderType }}</vs-chip>
            </vs-td>
            <vs-td v-if="order.orderType == 'Ouro'">
              <vs-chip color="#DAA520">{{ order.orderType }}</vs-chip>
            </vs-td>
               <vs-td v-if="order.orderType == 'Equipamentos Revisão'">
              <vs-chip color="primary">{{ order.orderType }}</vs-chip>
            </vs-td>
            <vs-td align="left">
              <vx-tooltip :text="order.userName" position="left">
                <vs-avatar
                  :src="order.photo"
                  size="30px"
                  class="border-2 border-white border-solid -m-1"
                ></vs-avatar>
              </vx-tooltip>
            </vs-td>
            <vs-td>
              <div align="center">
                <vs-dropdown vs-custom-content vs-trigger-click>
                  <a
                    class="flex items-center"
                    style="font-weight: 500; font-size: 1rem"
                    href="#"
                  >
                    Mais <i class="material-icons"> expand_more </i>
                  </a>
                  <vs-dropdown-menu class="w-48">
                    <vs-dropdown-item
                      @click="checkToRestore(order.idOrder, order.orderType)"
                    >
                      <font-awesome-icon :icon="['fas', 'reply']" class="w-4" />
                      Restaurar
                    </vs-dropdown-item>
                    <!--<vs-dropdown-item divider> Option 3 </vs-dropdown-item>
                    <vs-dropdown-item> Option 2 </vs-dropdown-item>-->
                    <vs-dropdown-item
                      divider
                      @click.stop="deleteData(order.idOrder, order.orderType)"
                    >
                      <font-awesome-icon
                        :icon="['far', 'trash-alt']"
                        class="w-4"
                      />
                      Excluir
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </div>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <OrderReport ref="orderReport"></OrderReport>
  </div>
</template>

<script>
import axios from "axios";
import { baseApiUrl } from "@/global";
import { momentJS } from "@/helpers";
import OrderReport from "../report/orderReport";
export default {
  components: {
    OrderReport,
  },
  data() {
    return {
      trash: [],
      selected: [],
      equipmentOrders: [],
      itemsPerPage: 100,
      isMounted: false,
      addNewDataSidebar: false,
      sidebarData: {},
      momentJS: null,
      popupActive: false,
      dataStage: null,
      stage: null,
    };
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
    queriedItems() {
      return this.$refs.table
        ? this.$refs.table.queriedResults.length
        : this.trash.length;
    },
  },
  methods: {
    async restore(url,idOrder) {
      try {
        this.$vs.loading();
        const res = await axios.post(`${baseApiUrl}/${url}/restore`, {
          idOrder,
        });
        const orderIndex = this.trash.findIndex((e) => e.idOrder == idOrder);
        this.trash.splice(orderIndex, 1);
      } catch (error) {
        console.log(error);
        this.$vs.notify({
          title: "Erro",
          text: "Erro ao restaurar.",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    async checkToRestore(idOrder, orderType) {
      if (orderType == "Equipamento Revenda") {
        await this.restore("equipmentOrder",idOrder);
      }
      if (orderType == "Equipamento Venda Direta") {
        await this.restore("equipmentOrder",idOrder);
      }
      if (orderType == "Suprimentos") {
        await this.restore("suppliesOrder",idOrder);
      }
       if (orderType == "Mídias") {
        await this.restore("suppliesOrder",idOrder);
      }
      if (orderType == "Peças") {
        await this.restore("partsOrder",idOrder);
      }
      if (orderType == "Suprimentos Locação") {
        await this.restore("leaseSuppliesOrder",idOrder);
      }
      if (orderType == "Mão de Obra") {
        await this.restore("laborOrder",idOrder);
      }
      if (orderType == "Locação") {
        await this.restore("leaseOrder",idOrder);
      }
      if (orderType == "Ouro") {
        await this.restore("goldOrder",idOrder);
      }
       if (orderType == "Equipamentos Revisão") {
        await this.restore("equipmentReviewOrder",idOrder);
      }
    },
    async deleteData(idOrder, orderType) {
     
      let payload = {
          idOrder: idOrder,
          notify: this.$vs.notify,
          loading: this.$vs.loading,
      };
      let action;
      if (orderType == "Equipamento Revenda") {
        action = "equipments/removeEquipmentOrder";
      }
      if (orderType == "Equipamento Venda Direta") {
        action = "equipments/removeEquipmentOrder";
      }
      if (orderType == "Suprimentos") {
        action = "supplies/removeSuppliesOrder";
      }
      if (orderType == "Mídias") {
        action = "supplies/removeSuppliesOrder";
      }
      if (orderType == "Peças") {
        action = "parts/removePartsOrder";
      }
      if (orderType == "Suprimentos Locação") {
        action = "leaseSupplies/removeLeaseSuppliesOrder";
      }
      if (orderType == "Mão de Obra") {
        action = "labor/removeLaborOrder";
      }
      if (orderType == "Locação") {
        action = "lease/removeLeaseOrder";
      }
      if (orderType == "Ouro") {
        action = "gold/removeGoldOrder";
      }
        if (orderType == "Equipamentos Revisão") {
        action = "equipmentReview/removeEquipmentReviewOrder";
      }
      this.$store.dispatch(action, payload);
      const orderIndex = this.trash.findIndex((s) => s.idOrder == idOrder);
      this.trash.splice(orderIndex, 1);
    },
    getOrderStatusColor(status) {
      if (status == "on_hold") return "warning";
      if (status == "delivered") return "success";
      if (status == "canceled") return "danger";
      return "primary";
    },
    getPopularityColor(num) {
      if (num > 90) return "success";
      if (num > 70) return "primary";
      if (num >= 50) return "warning";
      if (num < 50) return "danger";
      return "primary";
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
    },
    async loadTrashItems() {
     
      this.$vs.loading();

      const resEquipments = await axios.get(
        `${baseApiUrl}/equipmentOrder/getEquipmentsOrder?type=trash`
      );
      const resLabor = await axios.get(
        `${baseApiUrl}/laborOrder/getLaborOrder?type=trash`
      );
      const resLease = await axios.get(
        `${baseApiUrl}/leaseOrder/getLeaseOrder?type=trash`
      );
      const resParts = await axios.get(
        `${baseApiUrl}/partsOrder/getPartsOrder?type=trash`
      );
      const resSupplies = await axios.get(
        `${baseApiUrl}/suppliesOrder/getSuppliesOrder?type=trash`
      );
      const resGold = await axios.get(
        `${baseApiUrl}/goldOrder/getGoldOrder?type=trash`
      );
      const resLeaseSupplies = await axios.get(
        `${baseApiUrl}/leaseSuppliesOrder/getLeaseSuppliesOrder?type=trash`
      );
       const resEquipmentReview = await axios.get(
        `${baseApiUrl}/equipmentReviewOrder/getEquipmentReviewOrder?type=trash`
      );
      this.$vs.loading.close();
      this.trash.push(...resEquipments.data)
      this.trash.push(...resLabor.data)
      this.trash.push(...resLease.data)
      this.trash.push(...resParts.data)
      this.trash.push(...resSupplies.data)
      this.trash.push(...resGold.data)
      this.trash.push(...resLeaseSupplies.data)
      this.trash.push(...resEquipmentReview.data)
    },
  },
  async created() {
    this.momentJS = momentJS();
    this.loadTrashItems();
  },
  mounted() {
    this.isMounted = true;
  },
};
</script>

<style lang="scss">
#data-list-thumb-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 10px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
          &.img-container {
            // width: 1rem;
            // background: #fff;

            span {
              display: flex;
              justify-content: flex-start;
            }

            .product-img {
              height: 110px;
            }
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
